const pushDataLayer = (nameDataLayer, data = {}) => {
    !!window && !!window.dataLayer && window.dataLayer.push({
        event: nameDataLayer,
        ...data
    });
};

export {
    pushDataLayer
};